/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum ChangePickupDateReason {
  CustomerRequested = "CustomerRequested",
  ShipperNotReady = "ShipperNotReady",
  CarrierMissedPickup = "CarrierMissedPickup",
  CustomerBookedLate = "CustomerBookedLate",
  Other = "Other",
}

export function instanceOfChangePickupDateReason(value: any): boolean {
  for (const key in ChangePickupDateReason) {
    if (Object.prototype.hasOwnProperty.call(ChangePickupDateReason, key)) {
      if (
        ChangePickupDateReason[key as keyof typeof ChangePickupDateReason] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function ChangePickupDateReasonFromJSON(
  json: any,
): ChangePickupDateReason {
  return ChangePickupDateReasonFromJSONTyped(json, false);
}

export function ChangePickupDateReasonFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ChangePickupDateReason {
  return json as ChangePickupDateReason;
}

export function ChangePickupDateReasonToJSON(
  value?: ChangePickupDateReason | null,
): any {
  return value as any;
}

export function ChangePickupDateReasonToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ChangePickupDateReason {
  return value as ChangePickupDateReason;
}
